/** Native "support" button linking to Ko-fi. No third-party script is loaded;
 *  the link only opens Ko-fi in a new tab when clicked, keeping pages offline-clean
 *  and avoiding an extra tracker in the privacy surface. */

export const KOFI_URL = 'https://ko-fi.com/barcid';

interface KofiButtonProps {
  /** 'solid' for a prominent CTA (About page), 'link' for footer text links. */
  variant?: 'solid' | 'link';
  /** Override the visible label. */
  label?: string;
}

export default function KofiButton({ variant = 'solid', label = 'Support Battle Standard' }: KofiButtonProps) {
  if (variant === 'link') {
    return (
      <a
        href={KOFI_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'var(--f-primary)', textDecoration: 'none' }}
      >
        {label}
      </a>
    );
  }

  return (
    <a
      href={KOFI_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 20px',
        borderRadius: '4px',
        backgroundColor: 'var(--f-gold)',
        color: 'var(--f-bg)',
        fontFamily: "'Cinzel', Georgia, serif",
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        textDecoration: 'none',
        border: '1px solid var(--f-gold)',
        transition: 'opacity 0.2s',
      }}
    >
      <span aria-hidden="true" style={{ fontSize: '14px' }}>☕</span>
      <span>{label}</span>
    </a>
  );
}
